import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useEffect, useState } from 'react';
import styles from './Toggle.module.css';
const ToggleComponent = (props) => {
    const [checked, setChecked] = useState(props.checked ?? false);
    useEffect(() => {
        setChecked(props.checked ?? false);
    }, [props.checked]);
    const handleChange = (e) => {
        const newValue = e.target.checked;
        setChecked(newValue);
        props.onChange?.(newValue);
    };
    return (_jsxs("label", { className: `${styles.switch}  ${props.className ?? ''}`, style: { ...props.style }, children: [_jsx("input", { type: 'checkbox', name: props.name, checked: checked, onChange: handleChange, "data-testid": props.dataTestid, "aria-label": props.ariaLabel, disabled: props.disabled }), _jsx("span", { className: `${styles.slider} ${styles.round} ${props.disabled ? styles.disabled : ''}` })] }));
};
export const Toggle = memo(ToggleComponent);
